import { lazyLoad } from 'utils/lazy';

export const Migrations = lazyLoad(
  () => import('./Migrations'),
  (module) => module.MigrationsPage
);
